import React from 'react'

import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'

import {
  IconPane,
  IconWrapper,
  IconsGrid,
  BenefitCard,
  BenefitText,
} from './style'
import whyWorkForUsItems from './whyWorkForUsItems'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'

function WhyWorkForUs() {
  return <Pane type="clear">
    <PaneBody size="xl-y md">
      <LayoutContainer>
        <Heading
          variant="heading3"
          align="center"
          as="h2"
        >
          Why work for us?
        </Heading>
        <BodyText as="p" variant="large" align="center">
          We consider our people one of our most important assets – and we want our team to love their working lives! When you work for Luxury Escapes, you can look forward to:
        </BodyText>
        <IconsGrid>
          {whyWorkForUsItems.map((item) =>
            <IconWrapper key={item.title}>
              <IconPane type="clean">
                <PaneBody size="md lg-y">
                  <BenefitCard>
                    <div>{item.icon}</div>
                    <BenefitText>
                      <BodyText variant="large" weight="bold">{item.title}</BodyText>
                      <BodyText variant="small">{item.text}</BodyText>
                    </BenefitText>
                  </BenefitCard>
                </PaneBody>
              </IconPane>
            </IconWrapper>,
          )}
        </IconsGrid>
      </LayoutContainer>
    </PaneBody>
  </Pane>
}

export default WhyWorkForUs
